import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default function ConfirmUpdateDialog({
  open,
  onClose,
  onConfirm,
  fields,
}) {
  const fieldLabels = {
    client_id: 'Client ID',
    client_secret: 'Client Secret',
    certificado: 'Certificado (.crt)',
    chave_privada: 'Chave Privada (.key)',
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      BackdropProps={{
        className: '',
        style: { backgroundColor: alpha('#246E47', 0.3) },
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Confirmar Atualização</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Os seguintes campos serão atualizados:
        </Typography>
        <List dense>
          {fields.map((field) => (
            <ListItem key={field}>
              <ListItemIcon style={{ minWidth: 36 }}>
                <CheckCircleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={fieldLabels[field] || field} />
            </ListItem>
          ))}
        </List>
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
          Campos não listados acima serão mantidos sem alterações.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
